import { render, staticRenderFns } from "./pkg30.vue?vue&type=template&id=6cc0f1be&"
import script from "./pkg30.vue?vue&type=script&lang=js&"
export * from "./pkg30.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports